export const SunMark = ({ size = 40, className = "", animate = true }) => {
  const rays = Array.from({ length: 12 }, (_, i) => i * 30);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      aria-label="1st Nations Security sun logo"
      role="img"
    >
      <defs>
        <radialGradient id="sunCore" cx="50%" cy="42%" r="65%">
          <stop offset="0%" stopColor="#FFB300" />
          <stop offset="70%" stopColor="#F57C00" />
          <stop offset="100%" stopColor="#E65100" />
        </radialGradient>
      </defs>
      <g className={animate ? "animate-spin-slow" : ""} style={{ transformBox: "fill-box", transformOrigin: "center" }}>
        {rays.map((deg) => (
          <polygon
            key={deg}
            points="50,2 44,22 56,22"
            fill="#FFB300"
            transform={`rotate(${deg} 50 50)`}
            className={animate ? "animate-ray-pulse" : ""}
            style={animate ? { animationDelay: `${(deg / 30) * 0.33}s`, transformOrigin: "50px 50px" } : { transformOrigin: "50px 50px" }}
          />
        ))}
      </g>
      <circle cx="50" cy="50" r="26" fill="url(#sunCore)" />
      <circle cx="50" cy="50" r="26" fill="none" stroke="#FFB300" strokeWidth="1.5" opacity="0.6" />
    </svg>
  );
};
